// extracted by mini-css-extract-plugin
module.exports = {"width":"Gallery_width__GalFB"};